import React, { useEffect } from 'react'
import { AiFillRobot, AiFillPieChart, AiFillCreditCard } from 'react-icons/ai'
import { MdLiveTv } from 'react-icons/md'
import { IoMdRecording } from 'react-icons/io'
import { IoMdAnalytics } from 'react-icons/all'
import { RiTaskLine } from 'react-icons/ri'
import { FaProjectDiagram } from 'react-icons/fa'

import { Container, Description } from './Styled'
import { navigate } from '@reach/router'
import { ShowcaseCard } from '@locuta/locuta-ui'
import { selectUserRoles } from '../../../business/selectors/userSelectors'
import { useSelector } from 'react-redux'
import { isAuthorized, Role } from '../../../helpers/rolesHelper'
type MenuProps = {}

export const Menu: React.FunctionComponent<MenuProps> = (props) => {
    const userRoles: string | string[] = useSelector(selectUserRoles)
    useEffect(() => {
        const script = document.createElement('script')
        script.src =
            'https://locuta.atlassian.net/s/en_US-ydn9lh-418945332/803/1088/1.2/_/download/batch/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector/com.atlassian.jira.collector.plugin.jira-issue-collector-plugin:issuecollector.js?collectorId=2755b6fe'
        script.async = true
        document.body.appendChild(script)
        //@ts-ignore
        window.ATL_JQ_PAGE_PROPS = {
            //@ts-ignore
            triggerFunction: function (showCollectorDialog) {
                //@ts-ignore
                jQuery('#issueTrigger').click(function (e) {
                    e.preventDefault()
                    showCollectorDialog()
                })
            },
        }

        return () => {
            document.body.removeChild(script)
            //@ts-ignore
            delete window.ATL_JQ_PAGE_PROPS.triggerFunction
        }
    }, [])

    return (
        <Container>
            {(isAuthorized(userRoles, Role.Builder) === true
            || isAuthorized(userRoles, Role.BuilderVisitor)) && (
                <ShowcaseCard
                    style={{ height: '350px', width: '250px' }}
                    onClick={() => navigate('bots')}
                    Icon={<AiFillRobot color="white"></AiFillRobot>}
                    isColored={true}
                    title="Agents conversationnels"
                    Content={
                        <Description>
                            Créer ou configurez vos agents conversationnels
                        </Description>
                    }
                />
            )}
            {isAuthorized(userRoles, Role.Statistic) === true && (
                <>
                    <ShowcaseCard
                        style={{ height: '350px', width: '250px' }}
                        onClick={() => navigate('live')}
                        Icon={<MdLiveTv color="white"></MdLiveTv>}
                        isColored={true}
                        title="Tableau de bord"
                        Content={
                            <Description>
                                Suivez en temps réel l’activité de vos agents conversationnels
                                afin d’augmenter leur productivité.
                            </Description>
                        }
                    />
                    <ShowcaseCard
                        style={{ height: '350px', width: '250px' }}
                        onClick={() => navigate('statistic')}
                        Icon={<AiFillPieChart color="white"></AiFillPieChart>}
                        isColored={true}
                        title="Statistiques"
                        Content={
                            <Description>
                                Évaluez votre performance et la qualité de vos agents
                                conversationnels. Mesurez le pourcentage d’appels manqués, la
                                durée moyenne d’un appel, etc.
                            </Description>
                        }
                    />
                </>
            )}
            {isAuthorized(userRoles, Role.Transcription) === true && (
                <ShowcaseCard
                    style={{ height: '350px', width: '250px' }}
                    onClick={() => navigate('transcription')}
                    Icon={<IoMdRecording color="white"></IoMdRecording>}
                    isColored={true}
                    title="Transcriptions"
                    Content={
                        <Description>
                            Consultez l'historique des conversations téléphonique
                        </Description>
                    }
                />
            )}
            {isAuthorized(userRoles, Role.Finance) === true && (
                <ShowcaseCard
                    style={{ height: '350px', width: '250px' }}
                    onClick={() => navigate('billing')}
                    Icon={<AiFillCreditCard color="white"></AiFillCreditCard>}
                    isColored={true}
                    title="Facturation"
                    Content={<Description>Suivez votre consommation</Description>}
                />
            )}
            <ShowcaseCard
                style={{ height: '350px', width: '250px' }}
                id="issueTrigger"
                onClick={() => { }}
                Icon={<RiTaskLine color="white"></RiTaskLine>}
                isColored={true}
                title="Bug tracker"
                Content={<Description>Signaler une anomalie</Description>}
            />
            {isAuthorized(userRoles, Role.Statistic) === true && (
                <ShowcaseCard
                    style={{ height: '350px', width: '250px' }}
                    onClick={() => navigate('monitoringGraph')}
                    Icon={<FaProjectDiagram color="white"></FaProjectDiagram>}
                    isColored={true}
                    title="Monitoring Graph"
                    Content={
                        <Description>
                            Consultez la représentation graphique de vos conversations
                        </Description>
                    }
                />
            )}
            {isAuthorized(userRoles, Role.Statistic) === true && (
                <ShowcaseCard
                    style={{ height: '350px', width: '250px' }}
                    onClick={() => navigate('analytics')}
                    Icon={<IoMdAnalytics color="white"></IoMdAnalytics>}
                    isColored={true}
                    title="Analytics"
                    Content={
                        <Description>
                            Accéder à l'analytique de vos appels pour suivre les performances et détecter les anomalies
                        </Description>
                    }
                />
            )}
        </Container>
    )
}

export default Menu
